/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpeciesCandidate
 */
export interface SpeciesCandidate {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    commonName?: string | null;
    /**
     * 
     */
    score: number;
}

/**
 * Check if a given object implements the SpeciesCandidate interface.
 */
export function instanceOfSpeciesCandidate(value: object): value is SpeciesCandidate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function SpeciesCandidateFromJSON(json: any): SpeciesCandidate {
    return SpeciesCandidateFromJSONTyped(json, false);
}

export function SpeciesCandidateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpeciesCandidate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'commonName': json['common_name'] === undefined ? undefined : json['common_name'] === null ? null : json['common_name'],
        'score': json['score'],
    };
}

export function SpeciesCandidateToJSON(json: any): SpeciesCandidate {
    return SpeciesCandidateToJSONTyped(json, false);
}

export function SpeciesCandidateToJSONTyped(value?: SpeciesCandidate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'common_name': value['commonName'],
        'score': value['score'],
    };
}

